import type { PortfolioState } from './types';

export const createEmptyPortfolioState = (): PortfolioState => ({
  schemaVersion: 1,
  companies: [],
  investments: [],
  snapshots: [],
  issues: [],
  risks: [],
  reports: [],
  opportunities: [],
});
